import React, { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import className from 'classnames';
import { Spinner } from 'react-bootstrap';
import DataTable from 'react-data-table-component';

import { getQuestionsByProvider } from '../../../_actions/question-library.action'
import QuestionsEmpty from './Empty';

const dataTableColumns = [
  {
    name: 'ID',
    selector: 'id',
    sortable: false,
    width: '75px'
  },
  {
    name: 'Status',
    sortable: false,
    cell: (question) => {
      const badge = className('badge', 'text-uppercase', {
        'badge-primary': question.status === 'verified',
        'badge-secondary': question.status === 'unverified',
        'badge-warning': question.status === 'unknown'
      });

      return <span className={badge}>{question.status}</span>;
    },
    width: '100px'
  },
  {
    name: 'Question',
    sortable: false,
    cell: question => question.resource.text.length > 80 ? question.resource.text.substring(0, 70) + '...' : question.resource.text
  },
  {
    button: true,
    cell: question => <Link className="btn btn-outline-primary" to={`/questions/${question.id}/edit`}>Edit</Link>
  }
]

const FilterComponent = ({ filterText, onFilter, onClear }) => (
  <>
    <input style={{
      width: '250px',
      marginRight: '10px'
    }} value={filterText} onChange={onFilter} type="text" className="form-control" placeholder="Filter by definition or question"></input>
    <button onClick={onClear} type="button" className="btn btn-secondary">X</button>
  </>
);

const List = () => {
  const isLoading = useSelector(state => state.questionLibrary.isLoading);
  const collection = useSelector(state => state.questionLibrary.collection);

  const dispatch = useDispatch();

  const [filterText, setFilterText] = useState('');
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const filteredData = collection.data.filter((question) => {
    return question.resource.text && question.resource.text.toLowerCase().includes(filterText.toLowerCase());
  });

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText('');
      }
    };

    return <FilterComponent
      onFilter={e => setFilterText(e.target.value)}
      onClear={handleClear}
      filterText={filterText} />
  }, [filterText, resetPaginationToggle]);

  useEffect(() => {
    dispatch(getQuestionsByProvider());
  }, [dispatch]);

  return (
    <div className="row">
      <div className="col-lg-8">
        <h3>Question Library</h3>
      </div>

      <div className="col-lg-4 text-right">
        <Link className="btn btn-primary rounded" to="/questions/create">
          <i className="fa fa-plus"></i>&nbsp; Create Question
        </Link>
      </div>

      <div className="col mt-4">
        <div className="card axs-shadow">
          <div className="card-body">

            {isLoading &&
              <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>
            }

            {!isLoading && collection.data.length === 0 &&
              <QuestionsEmpty />
            }

            {!isLoading && collection.data.length > 0 &&
              <DataTable
                noHeader={true}
                columns={dataTableColumns}
                data={filteredData}
                striped={true}
                pagination={true}
                subHeader
                subHeaderComponent={subHeaderComponentMemo}
                noDataComponent={<div className="p-4">We could not find any results based on your search criteria</div>}
                customStyles={{ cells: { style: { fontSize: '14px' }, }, }}
              />
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default List;